<template>
<div>
  <main-header-nav :content="content"></main-header-nav>
  <iframe
    style="border: 0px;width: calc(100% - 250px);height: calc(100% - 106px);position:absolute;top: 106px;"
    :src="this.$route.params.type === 'upload' ? 'http://www.scbimzjzb.cn/models/' + this.$route.params.id + '/web-mobile/index.html' : 'http://www.scbimzjzb.cn/3d-building/?id=' + this.$route.params.id + '&data=' + this.$route.params.data"
  >
  </iframe>
</div>
</template>
<script>
import MainHeaderNav from '../common/MainHeaderNav'
export default {
  name: 'VirtualBuilding',

  components: {
    MainHeaderNav
  },

  data () {
    return {
      src: '',
      content: ''
    }
  },

  mounted () {
    var self = this

    this.getRequest('/cost_estimates/' + this.$route.params.id)
      .then(resp => {
        if (resp && resp.result) {
          self.content = resp.result.name + '-三维建筑模型'
        }
      })
  }
}
</script>
<style scoped>

</style>
